import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IconfontModule} from '../../pipes/iconfont.pipe';
import {ChosenPluginsComponent} from './chosen-plugins.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IconfontModule
  ],
  exports: [ChosenPluginsComponent],
  declarations: [ChosenPluginsComponent]
})
export class ChosenPluginsModule { }




// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/components/chosen-plugins/chosen-plugins.module.ts